<template>
    <div v-if="showDrawer()">
        <div class="drawer-trigger"  @click="openDrawer">
            <div class="drawer-icon" @mouseenter="openDrawer">
                <div class="ivu-drawer-drag-move-trigger">
                    <div class="ivu-drawer-drag-move-trigger-point"><i></i><i></i><i></i><i></i><i></i></div>
                </div>
            </div>
        </div>
        <div>
            <Drawer title="" placement="left" :closable="true" v-model="drawOpen" :width="dynamicWidth" :draggable="false"
                :mask="false" :transfer="false" :multiple="false" 
                class="my-drawer menu-actions" @on-close="removeLayoutOffset" ref="drawer">              
                    <div class="drawer-title">
                        <Tooltip :content="openState ? getTranslation('l010') : getTranslation('l011')" placement="bottom" theme ="light" :transfer="true">
                        <Button :type="openState ? 'default' : 'primary'" :icon="openState ? 'md-contract' : 'md-expand'"
                        @click="revert()" class="btn-toggle" size="small" /></Tooltip>&nbsp;<Input  size="small" v-model="searchKey" @on-enter="search()" :placeholder="getTranslation('m134')" style="width: 60%;"/>&nbsp;
                    <Tooltip :content="getTranslation('k176')" theme ="light" :transfer="true">
                    <Button type="primary" size="small" @click.native="search()" shape="circle" icon="ios-search"></Button></ToolTip>&nbsp;
                    </div>
                <Tree :key="selectionVersion" :data="drawData" :render="renderContent" class="tree-render"
                      @on-select-change="selectMachine"
                      empty-text=""></Tree>
                <!-- 右侧拖拽调整宽度的把手 -->
                <div class="drawer-resizer" @mousedown="startResize"></div>
            </Drawer>
        </div>
        <WebSocket ref="webSocketRef" :url="webSocketUrl" @receive-message="receiveMessage"></WebSocket>
    </div>
</template>
<script>
import WebSocket from '@/components/WebSocket.vue';
import { mapGetters } from 'vuex'
import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { postJsError } from '@/util/util.js'
import { EventBus } from '@/store/event-bus.js';
export default {
    name: 'AppDrawer',
    components: {
       WebSocket
    },
    computed: {
        ...mapGetters(['getTranslation']),
        drawData() {
            let filteredData = [];
            if (this.originData) {
                filteredData = this.originData.filter(item => item.machines && item.machines.length > 0);
            } else {
                filteredData = []
            }
            filteredData.forEach(productline => {
                productline.children = productline.machines.map(machine => ({
                    id: machine.id,
                    name: machine.code,
                    isMachine: true,
                    state: machine.state,
                    kind:machine.kind,
                    selected: machine.id === this.selectedMachineId, // 恢复选中状态
                }));
                // 如果该产线有选中的机器，展开该产线
                if (this.selectedMachineId && productline.children.some(child => child.selected)) {
                    productline.expand = true;
                }
            });

            return filteredData;
        },
        webSocketUrl() {
            return API_URL['webSocket'];
        },
        openStateMap() {
            return {
                0: this.getTranslation("l011"),
                1: this.getTranslation("l010"),
            }
        },
    },
    props: {
    },
    data() {
        return {
            drawOpen: false,
            originData:[],            
            // force Tree refresh after selection changes
            selectionVersion: 1,
            dynamicWidth: 256, // 初始宽度
            warnList: {},
            openState: 0,
            isFirstSelect :true,
            // 拖拽相关
            resizing: false,
            resizeStartX: 0,
            resizeStartWidth: 0,
            minWidth: 256,
            maxWidth: 2000,
            suppressSelectChange: false,
            searchKey:'',
            selectedMachineId: null, // 保存选中的机器ID
            canReconnectWebSocket:false,
        }
    },
    created() {
        this.initData();
        EventBus.$on('machine-add', this.getData);

    },
    watch: {
        // 当抽屉打开/关闭时，动态设置页面左侧空白以“占位”
        drawOpen(val) {
            if (val) {
                this.applyLayoutOffset();
            } else {
                this.removeLayoutOffset();
            }
        },
        dynamicWidth() {
            // 抽屉打开时，随宽度变化更新占位
            if (this.drawOpen) this.applyLayoutOffset();
        }
    },
    methods: {
        async initData() {
            await this.getData();            
        },
        async getData() {
            let url = API_URL["productlineGetWithMachine"];
            let res =await axios.get(url,{ timeout: 300000 })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
            if (res && res.data && res.data.code == 200) {
                this.originData = res.data.data;
                // data 更新后断开并重连 WebSocket，刷新机器连接状态
                if (this.canReconnectWebSocket){
                    this.reconnectWebSocket();
                }else {
                    this.canReconnectWebSocket = true;
                }
                
            }
        },
        openDrawer() {
            this.drawOpen = true
        },
        turntoPage(data) {            
            let urlPath = {
                path: '/middle',
                query: { mac: data.id,kind:data.kind }
            };

            this.$router.push(urlPath)
           
            //this.drawOpen = false
        },
        showDrawer() {
            let rs = true
            if (this.$route.path === '/middle' || this.$route.path.substring(0, 4) === '/doc' || this.$route.path === '/login' || this.$route.path === '/download') {
                rs = false;
            }
            return rs;
        },
        clearSelection() {
            this.selectedMachineId = null; // 清除保存的选中ID
            const walk = (nodes) => {
                if (!Array.isArray(nodes)) return;
                nodes.forEach(n => {
                    this.$set(n, 'selected', false);
                    if (Array.isArray(n.children) && n.children.length) walk(n.children);
                });
            };
            walk(this.drawData);
        },        
        toggleNode(node, data, e) {
            if (e) e.stopPropagation();
            if (data && Array.isArray(data.children) && data.children.length) {
                const next = !(data.expand === true);
                this.$set(data, 'expand', next);
                if (node && typeof node.expand !== 'undefined') node.expand = next;
            }
        },
        renderContent(h, { node, data }) {
            let iconVNode;
            var title = data.name;
            let fontSize = '14px';
            let fontWeight ='500'
            let color = '#515a6e';
            if (data.isMachine) {
                // 机器节点：根据 state 显示状态圆点
                const raw = data.state == null ? '' : String(data.state).toLowerCase();
                const map = {
                    '1': 'online',
                    '4': 'reconnect',
                    '2': 'alarm',
                    '0': 'offline',
                }
                const key = map[raw] || 'offline';
                iconVNode = h('i', {
                    class: ['status-dot', `status-${key}`],
                    style: { marginRight: '8px' }
                });
            } else {
                 fontSize = '15px';
                fontWeight = '550';
                color = '#303133';
                // 产线图标 + 展开/折叠箭头
                const isOpen = data.expand === true || node.expand === true;
                iconVNode = h('span', {
                    style: { marginRight: '4px', display: 'inline-flex', alignItems: 'center' }
                }, [
                    h('Icon', {
                        props: { type: isOpen ? 'md-arrow-dropdown' : 'md-arrow-dropright', size: 14 },
                        style: { cursor: 'pointer', color: '#606266' },
                        on: {
                            click: (e) => {
                                e.stopPropagation();
                                this.toggleNode(node, data);
                            }
                        }
                    }),
                   
                ]);                
                let onlineCount = data.children.filter(item => item.state == 1  || item.state == 2).length;
                title += '('+ onlineCount+'/'+data.children.length+')';
            }

            let clickHandler = {
                click: () => {
                    if (!data.isMachine) {
                        this.toggleNode(node, data);
                    }
                }
            };

            return h('span', {
                on: clickHandler,
                style: { display: 'inline-block', width: '100%' },
                class: { 'tree-item': true, 'is-selected': data.selected === true }
            }, [
                h('span', [
                    h('span', { style: { cursor: 'pointer', display: 'inline-flex', alignItems: 'center' } }, [
                        iconVNode,
                        h('span', { style: { cursor: 'pointer',fontSize:fontSize ,fontWeight:fontWeight, color:color} }, title)
                    ])
                ]),
                h('span', { style: { display: 'inline-block', float: 'right' } }, [

                ])
            ]);
        },
        receiveMessage(obj) {
            if (obj && obj.kind) {
                switch (obj.kind) {
                    case 'state':
                        if (obj.data.offline === true) {
                            this.setMachineState(obj.data.macId, 0)
                        } else {
                            if (obj.data.netState === 0) {
                                this.setMachineState(obj.data.macId, 4)
                            } else if (obj.data.netState === 1) {
                                this.setMachineState(obj.data.macId, 1)
                            }
                        }
                        break;
                    case 'warnList':
                        if (obj.data) {
                            if (obj.data.clear) {
                                this.$set(this.warnList, obj.data.macId, null);
                                if (this.drawData) {
                                    this.drawData.forEach((item) => {
                                        item.machines && item.machines.forEach((oneMachine) => {
                                            if (oneMachine.id == obj.data.macId && oneMachine.state == 2) {
                                                this.$set(oneMachine, 'state', 1);
                                                this.selectionVersion += 1; // force re-render
                                            }
                                        })
                                    })
                                }
                            } else {
                                this.$set(this.warnList, obj.data.macId, obj.data.alarms || []);
                                
                                this.setMachineState(obj.data.macId, 2)
                            }

                        }
                        break;
                    default:
                        break;
                }
            }
        },
        // 断开并重连 WebSocket（getData/search 后调用）
        reconnectWebSocket() {
            const wsComp = this.$refs.webSocketRef;
            if (!wsComp) return;
            wsComp.disconnectWebSocket();
            wsComp.connectWebSocket();
        },
        setMachineState(id, state) {            
            this.originData && this.originData.forEach((item) => {
                item.machines && item.machines.forEach((oneMachine) => {
                    if (oneMachine.id == id) {
                        this.$set(oneMachine, 'state', state);
                        this.selectionVersion += 1; // force re-render

                    }
                })
            })
        },
        revert() {
            let expandState = this.openState == 1 ? 0 : 1;            
            this.drawData && this.drawData.forEach((item) => {
                this.$set(item, 'expand', expandState);
            })
            this.openState = this.openState == 1 ? 0 : 1;
            this.selectionVersion += 1;            
            
        },
        applyLayoutOffset() {
            try {
                // 使用 body 左内边距来“占位”抽屉宽度
                document.body.style.transition = 'padding-left 0.2s ease';
                document.body.style.paddingLeft = `${this.dynamicWidth}px`;
                // 允许右侧主内容继续纵向滚动（避免 Drawer 打开时被锁滚动）
                document.body.style.overflowY = 'auto';
                document.body.style.overflowX = 'hidden';
                document.documentElement.style.overflowY = 'auto';
            } catch (e) {
                this.selectionVersion += 1;
            }
        },
        removeLayoutOffset() {
            try {
                document.body.style.paddingLeft = '';
                document.body.style.overflowY = '';
                document.body.style.overflowX = '';
                document.documentElement.style.overflowY = '';
            } catch (e) {
                this.selectionVersion += 1;
            }
        },
        startResize(e) {
            e.preventDefault();
            this.resizing = true;
            this.resizeStartX = e.clientX;
            this.resizeStartWidth = this.dynamicWidth;
            // 视觉/交互反馈
            document.body.style.cursor = 'col-resize';
            document.body.style.userSelect = 'none';
            window.addEventListener('mousemove', this.onResizing);
            window.addEventListener('mouseup', this.stopResize);
        },
        onResizing(e) {
            if (!this.resizing) return;
            const dx = e.clientX - this.resizeStartX;
            const raw = this.resizeStartWidth + dx;
            const max = Math.min(this.maxWidth, window.innerWidth * 0.8);
            const next = Math.max(this.minWidth, Math.min(raw, max));
            this.dynamicWidth = next;
        },
        stopResize() {
            if (!this.resizing) return;
            this.resizing = false;
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
            window.removeEventListener('mousemove', this.onResizing);
            window.removeEventListener('mouseup', this.stopResize);
        },
        selectMachine(selected, data) {
            // 防止重复触发
            
            // 仅处理机器节点的选择
            if (!data || !data.isMachine) return;

            this.suppressSelectChange = true;

            const targetId = data.id;
            // 保存选中的机器ID
            this.selectedMachineId = targetId;
            
            // 清空所有选中，仅保留当前机器及其父区域的选中态
            this.drawData && this.drawData.forEach(line => {
                let parentSelected = false;
                // 清空父节点选中
                this.$set(line, 'selected', false);
                if (Array.isArray(line.children)) {
                    line.children.forEach(m => {
                        const isTarget = m.id == targetId;
                        this.$set(m, 'selected', isTarget);
                        if (isTarget) {
                          parentSelected = true;
                          // 确保父节点展开
                          this.$set(line, 'expand', true);
                        }
                    });
                }
                if (parentSelected) {
                  this.$set(line, 'selected', true);
                }
            }); 
            this.selectionVersion += 1;          
            if(this.isFirstSelect){
                setTimeout(() => {
                    this.selectMachine(selected, data); // 强制刷新一次选中状态
                }, 200);                
                 // 跳转到页面
              
                this.isFirstSelect =false
                // 强制刷新一次渲染但避免再次触发 select-change                
            }else {
                this.turntoPage(data);
            }
            
        },
        async search(){
            await this.getData();            
            if (this.searchKey && this.searchKey.trim() !== '') {
                const key = this.searchKey.trim().toLowerCase();
                // 深拷贝原始数据，避免修改原始数据
                this.originData.forEach((item) => {
                if (!item.machines) {
                    item.machines = [];
                    return;
                }                
                item.machines = item.machines.filter((machine) => {
                    return machine.name.toLowerCase().includes(key) ||
                    machine.code.toLowerCase().includes(key) ||
                    machine.address.toLowerCase().includes(key);
                });
                item.expand = true;                    
                });                
            } else {
                // 如果清空搜索，恢复原始数据
                this.selectedMachineId = null;
            }
            this.selectionVersion += 1;
        }
    },
    beforeDestroy() {
        // 组件销毁时确保清理占位样式
        this.removeLayoutOffset();
        // 确保拖拽事件清理
        window.removeEventListener('mousemove', this.onResizing);
        window.removeEventListener('mouseup', this.stopResize);

        this.$eventBus.$on('machine-add', this.getData)
    }
}
</script>

<style scoped>

/* 左侧细条触发器 */
.drawer-trigger {
    position: fixed;
    overflow: hidden;
    left: 0;
    top: 0;
    width: 10px;
    height: 100vh;
    background: rgb(81, 90, 110,0.6);
    cursor: pointer;
    z-index: 1000;
    transition: background 0.2s;
}

.drawer-trigger:hover {
    background: rgba(0, 0, 0, 0.3);
}

.drawer-icon {
    margin-left: 5px;
    width: 16px;
}

.tree-render {
    margin-top: 20px;
    width: 100%;
}



</style>
<style>
/* 机器节点状态圆点 */
.status-dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    vertical-align: middle;
}

.status-online {
    background: #19be6b;
}

/* 在线 */
.status-offline {
    background: #c0c4cc;
}

/* 离线 */
.status-alarm {
    background: #f5222d;
}

/* 告警 */
.status-reconnect {
    background: #faad14;
}

/* 重连 */
.ivu-drawer {
    min-width: 256px;
}
.btn-toggle {
  border-radius: 4px;
  font-weight: 400;
  transition: all 0.2s ease;

}

/* 右侧拖拽把手 */
.my-drawer .drawer-resizer {
  position: absolute;
  top: 0;
  right: 0;
  width: 6px;
  height: 100%;
  cursor: col-resize;
  background: transparent;
}

.my-drawer .drawer-resizer:hover {
  background: rgba(0,0,0,0.05);
}
.drawer-title{
    padding-bottom:10px;
    text-align: left;
    border-bottom: 1px solid #A8A8A8;
   
}

/* 统一行容器确保占满宽度（一级/二级树通用） */
.tree-item {
    display: inline-block;
    width: 100%;
    border-radius: 0; /* 移除圆角，更接近 Windows 风格 */
    transition: background 0.15s ease, color 0.15s ease;
    padding: 0 4px;
    
}

/* 让抽屉内容成为定位容器，便于绝对定位拖拽把手 */
.my-drawer .ivu-drawer-body {
  position: relative;
  background-color: #fbfbfb;
  border-right:1px solid #d3d3d5;
}
/* 选中态优先级高于 hover */
.tree-item.is-selected {
    background: #bae7ff; /* 淡蓝色背景 */
    color: #1890ff; /* 深蓝色文字 */
    border-radius: 0; /* 移除圆角，更接近 Windows 风格 */
    padding: 0 4px 0 4px; /* 调整左边距以容纳边框 */
    font-weight: 550;
    transition: background 0.2s ease, color 0.2s ease;   
}
.ivu-tree-title{
    width: 100%;
}
.my-drawer .ivu-tree-title:hover{
    background: #bae7ff;
    transform: scale(1.02); /* 添加轻微缩放效果 */
    transition: background 0.2s ease, transform 0.2s ease;
    color: #333333; 
    border-radius: 4px; 
    padding: 0 0; /* 确保有足够的内边距 */
    box-sizing: border-box; 
}

/* 隐藏默认树折叠箭头，使用自定义 Icon */
.menu-actions .ivu-tree-arrow {
  display: none;
}
</style>
